import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from 'lm-loading';

class App extends Component {

    render(){


        return (

            <div>
                <Loading isShow={ this.props.showState }/>
            </div>


        );

    }

}


const mapStateToProps = (state) => {

    return {

        showState: state.toastData.showState

    };

};

export default connect(mapStateToProps)(App);